<p>modal-motivos-atencion-claro works!</p>
<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <h3 class="">Finalizar atención</h3>
        <h6>Seleccione el motivo de la atención</h6>
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">
            <form [formGroup]="motivosForm" (ngSubmit)="submit()">

                <div class="col-12 mx-auto mb-4">
                    <label class="color-title-box">Seleccione un Motivo</label>
                    <div class="input-group text-center" style="margin-left: 12.5%;">
                        <ng-select [formControl]="motivoSelec" class="w-75 text-center">
                            <ng-option *ngFor="let motivo of listamotivos" [value]="motivo.idMotivo" class="text-center">{{motivo.motivo}}</ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="isSubmitted && motivoSelec.errors">
                        <div *ngIf="motivoSelec.errors!.required">
                            <small class="text-danger">Por favor seleccione un motivo de atención</small>
                        </div>
                    </div>
                </div>

                <hr>
                <div class="col-12">
                    <p>Observaciones</p>
                </div>
                <div class="col-12 mx-auto mb-4">
                    <input type="text" class="w-75" formControlName="observaciones">
                </div>

                <div class="row mx-auto">
                    <div class="col-12 text-center">
                        <button type="button" class="btn-color" type="submit">ENVIAR MOTIVO</button>
                    </div>
                </div>

            </form>


            <div class="col-12 mt-4">
                <a type="button" (click)="cerrar()">Volver</a>
            </div>
        </div>
    </div>
</div>